import type { AuthenticatedUserPayload } from '@Application/Security/Authentications/Actions/userAuthenticated';

export type AuthenticatedUserFetchedAction = {
	type: 'AUTHENTICATED_USER_FETCHED';
	payload: AuthenticatedUserPayload;
};

export default (payload: AuthenticatedUserPayload): AuthenticatedUserFetchedAction => ({
	type: 'AUTHENTICATED_USER_FETCHED',
	payload,
});
